import { createContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useGetMeQuery } from "src/api/services/patientApi";
import { PatientProfileType } from "src/api/types";

export const PatientContext = createContext<PatientProfileType | null>(null);

interface Props {
  children: React.ReactNode;
}
const PatientProvider = ({ children }: Props) => {
  const { data: patient } = useGetMeQuery();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (patient == null) return;

    if (i18n.language !== patient.profile.language) {
      i18n.changeLanguage(patient.profile.language);
    }
  }, [i18n, patient]);

  if (patient == null) {
    return null;
  }

  return (
    <PatientContext.Provider value={patient}>
      {children}
    </PatientContext.Provider>
  );
};

export default PatientProvider;
